import * as React from "react";
import { Fragment } from "react";
import {
  DatagridConfigurable,
  DateField,
  ExportButton,
  FilterButton,
  SelectColumnsButton,
  TextField,
  TextInput,
  TopToolbar,
  useRecordContext,
  WrapperField,
  SelectInput,
  ReferenceField,
  CreateButton,
  FunctionField,
  downloadCSV,
  useRedirect,
  Button
} from "react-admin";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useMediaQuery, Divider, Theme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Label, { statusText } from "../../components/Label";
import ComponentList from "../../components/PageComponents/ComponentList";
import { AccountFilter } from "../../components/PageComponents/ComponentList";
import { BulkActionButtons, ListActions } from "../../components/PageComponents/ComponentList";
import MobileGrid from "./MobileGrid";
import { Helmet } from "react-helmet-async";
import { datagridSx } from "../../components/PageComponents/datagridSx";
export const map = {
  ENABLED: {
    state: "info",
    text: "ENABLED",
    original: "ENABLED",
  },
  DISABLED: {
    state: "info",
    text: "DISABLED",
    original: "DISABLED",
  },
  PENDING: {
    state: "info",
    text: "PENDING",
    original: "tx_pending",
  },
  DONE: {
    state: "success",
    text: "DONE",
    original: "DONE",
  },
  ERROR: {
    state: "error",
    text: "ERROR",
    original: "error",
  },
  FAILED: {
    state: "error",
    text: "FAILED",
    original: "FAILED",
  }

};

const StatusLabel = () => {
  const { t }: { t: any } = useTranslation();
  let conversion = useRecordContext();

  if (!conversion.status) conversion.status = "ERROR";

  const statusKey = conversion?.status?.toUpperCase();
  const statusData = map[statusKey] || { text: "UNKNOWN", state: "warning" };
  const { text, state } = statusData;

  return (
    <Label color={state}>
      {t(statusText(text))}
    </Label>
  );
};


const ConversionList = () => (
  <>
    <Helmet>
      <title>Coinhouse Solutions - Conversions</title>
    </Helmet>
    <ComponentList
      title="Conversions"
      subtitle="Every crypto amount converted to euros, with its fees and status."
      /* filters={conversionFilters} */
      actions={<ListActions ressource="cryptoConversions" filters={conversionFilters} />}
      sort={{ field: 'ulid', order: 'DESC' }}
    >
      <TabbedDatagrid />
    </ComponentList>
  </>
);

const conversionFilters = [
  <AccountFilter />,
];


const customExporter = (data, fetchRelatedRecords, dataProvider, resource) => {
  const exportData = data.map(record => ({
    dateCreated: record.dateCreated,
    euroAmount: record.quote,
    fee: record.fees,
    cryptoAmount: record.base,
    currency: record.baseCurrency,
    status: record.status
  }));
  
  // Convert to CSV and download
  const csv = convertToCSV(exportData);
  downloadCSV(csv, 'crypto-conversions');
};

// Helper function to convert data to CSV
const convertToCSV = (data) => {
  if (!data || data.length === 0) return '';
  
  const headers = Object.keys(data[0]).join(',');
  const rows = data.map(item => 
    Object.values(item).map(value => 
      typeof value === 'string' ? `"${value.replace(/"/g, '""')}"` : value
    ).join(',')
  );
  
  return [headers, ...rows].join('\n');
};

const RedirectToCryptoConversionShowButton = () => {
  const record = useRecordContext();
  const redirect = useRedirect();

  if (!record) return null;

  return (
    <Button
      label="More details"
      onClick={() => redirect(`/cryptoOrders/${record.orderId}/show`)}
    >
      <VisibilityOutlinedIcon />
    </Button>
  );
};

const TabbedDatagrid = () => {
  const isXSmall = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down("sm")
  );
  const currency = useRecordContext()?.currency;
  return (
    <Fragment>
      <Divider />
      {isXSmall ? (
        <MobileGrid />
      ) : (
        <>
          <DatagridConfigurable
            bulkActionButtons={<BulkActionButtons ressource="cryptoConversions" />}
            rowClick={(id, basePath, record) => `/cryptoOrders/${record.orderId}/show`}
            sx={datagridSx}
          >
            <DateField source="dateCreated" showTime sortBy="ulid" locales="fr-FR" label="Created" />
            <FunctionField sortable={false}
              label="Payout amount"
              textAlign="right"
              render={(record) => `${record.quote}\u00A0€`}
            />
            <FunctionField sortable={false}
              label="Crypto amount"
              textAlign="right"
              render={(record) => `${record.base}\u00A0${record.baseCurrency.toUpperCase()}`}
            />
            <WrapperField sortable={false} label="Fees" textAlign="right">
            <FunctionField sortable={false}
              label="Fees"
              render={(record) => `${record.fees}\u00A0€`}
            />
            </WrapperField>
            <WrapperField label="Fees included" sortable={false}>
              <FunctionField sortable={false}
                render={(record) => (
                  <Label color={record.feesIncluded ? "success" : "secondary"}>
                    {record.feesIncluded ? "Yes" : "No"}
                  </Label>
                )}
              />
            </WrapperField>

            <ReferenceField source="accountId" reference="accounts" label="Account" sortable={false}>
              <TextField sortable={false} source="name" />
            </ReferenceField>
            <WrapperField sortable={false} label="Status">
              <StatusLabel />
            </WrapperField>
            <RedirectToCryptoConversionShowButton />
          </DatagridConfigurable>
        </>
      )}
    </Fragment>
  );
};

export default ConversionList;
